/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControl,
  FormGroup,
  FormControlLabel,
  Typography,
  Checkbox,
  LinearProgress,
  Grid,
} from "@material-ui/core";
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import GeneralButton from "../../components/Buttons";
import { useThemeData } from "../../context/ThemeDataContext";
//import { useCartData } from "../../context/CartProvider";
/* EQUESTRIAN categories*/

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  container: {
    marginBottom: "1rem",
    backgroundColor: "white",
    borderRadius: "0.5rem",
    boxShadow: "#adb5bd 1px 1px 2px 1px",
  },
  typograph: {
    letterSpacing: 'normal'
  },
  heading: {
    fontSize: theme.typography.pxToRem(18),
    flexBasis: "90%",
    flexShrink: 0,
    fontWeight: "bold",
  },
  productText: {
    fontSize: theme.typography.pxToRem(15),
  },
  staticAccordion: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: "bold",
  },
  staticAccordionSummary: {
    display: "block",
    margin: "0",
    minHeight: "30px",
  },
  title: {
    fontWeight: "bold",
    margin: "0.5rem",
  },
  button: {
    margin: "0.5rem",
    width: "-webkit-fill-available",
  },
}));

function AccordionCategories(props) {
  const {
    primary_color_2
  } = useThemeData().themeData.site.theme;
  // const { cartData } = useCartData().cart;
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);
  const [firstExpanded, setfirstExpanded] = useState(true);
  let propsData = props.data;
  const [data, setData] = useState(propsData.length > 0 ? propsData : []);
  let setIsSet = props.setIsSet;
  let isSet = props.isSet;

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleFirstChange = (panel) => (event, isExpanded) => {
    setfirstExpanded(isExpanded ? panel : false);
  };

  const handleCheck = (e, product, category) => {
    let { checked } = e.target;
    
    const selectedCatIndex = data.findIndex(
      (p) => p.categorie_id === category.categorie_id
    );
    const selectedProductIndex = data[selectedCatIndex].catproducts.findIndex(
      (c) => c.product_id === product.product_id
    );
    let oldArray = data;
    let categories = oldArray.map((c, i) =>
      i === selectedCatIndex
        ? {
            categorie_id: c.categorie_id,
            naam: c.naam,
            catproducts: c.catproducts.map((p, id) =>
              id === selectedProductIndex
                ? {
                    categorie_id: c.categorie_id,
                    product_id: p.product_id,
                    actie_prijs: p.actie_prijs,
                    formaat: p.formaat,
                    naam: p.naam,
                    product_type: p.product_type,
                    prijs: p.prijs,
                    shippingcost: p.shippingcost,
                    quantum_aantal: p.quantum_aantal,
                    quantum_perc: p.quantum_perc,
                    checked: checked,
                    productpakketdetails: p.productpakketdetails.map((pr) => ({
                      product_id: pr.product_id,
                      productdetail: pr.productdetail,
                    })),
                  }
                : p
            ),
          }
        : c
    );
    setData(categories);
  };

  useEffect(() => {
    if (propsData.length > 0 && !isSet) {
      let categories = new Set();
      let newCategories = new Set();
      propsData[0].folder.productlist.products.map((p) => {
        return categories.add(p.productdetail.productcategory);
      });
      let CatArray = Array.from(categories);

      function getUnique(arr, comp) {
        // store the comparison values in array
        const unique = arr
          .map((e) => e[comp])
          // store the indexes of the unique objects
          .map((e, i, final) => final.indexOf(e) === i && i)
          // eliminate the false indexes & return unique objects
          .filter((e) => arr[e])
          .map((e) => arr[e]);
        return unique;
      }
      let newArray = getUnique(CatArray, "naam");

      newArray
        .sort((a, b) => a.volgorde - b.volgorde)
        .map((c) => {
          let Category_with_products = {
            categorie_id: c.categorie_id,
            naam: c.naam,
            catproducts: propsData[0].folder.productlist.products
              .filter(
                (f) =>
                  f.productdetail.productcategory.categorie_id ===
                  c.categorie_id
              )
              .map((p) => ({
                categorie_id: c.categorie_id,
                product_id: p.product_id,
                formaat: p.productdetail.formaat,
                naam: p.productdetail.naam,
                product_type: p.productdetail.product_type,
                prijs: p.productdetail.prijs,
                actie_prijs: p.productdetail.actie_prijs,
                shippingcost: p.productdetail.shippingcost,
                quantum_aantal: p.productdetail.quantum_aantal,
                quantum_perc: p.productdetail.quantum_perc,
                checked: false,
                productpakketdetails:
                  p.productlink.productpakketdetails[0].products.map((pr) => ({
                    product_id: pr.product_id,
                    productdetail: pr.productdetail,
                  })),
              })),
          };
          return newCategories.add(Category_with_products);
        });
      let newCatArray = Array.from(newCategories);

      setData(newCatArray);
      setIsSet(true);
    }
  }, [data, isSet, setIsSet, propsData]);

  if (!isSet)
    return (
      <LinearProgress
        className="align-self-center"
        style={{ color: primary_color_2 }}
      />
    )
  if (propsData.length === 0) return props.t('Looks like we have a problem...')

  if (data.length === 0) return props.t('Looks like we have a problem...')

  return (
    <div className={classes.root}
         style={{
           textAlign: 'left'
         }}
    >
      {data.map((c, i) => (
        i === 0 ?
          <Accordion
            key={c.categorie_id}
            style={{ boxShadow: 'none' }}
            expanded={firstExpanded === true ? true : firstExpanded === c.categorie_id}
            onChange={handleFirstChange(c.categorie_id)}
          >
            <AccordionSummary
              expandIcon={
                firstExpanded === true || firstExpanded === c.categorie_id ? <RemoveIcon /> : <AddIcon />
              }
              aria-controls={`${c.categorie_id}bh-content`}
              id={`${c.categorie_id}bh-header`}
            >
              <Typography className={`${classes.heading} ${classes.typograph}`} align="left">{c.naam}</Typography>
            </AccordionSummary>
            <AccordionDetails>

                <FormControl className={classes.formControl}>
                  <FormGroup>
                    {c.catproducts.map((p) => (
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <FormControlLabel
                            key={p.product_id}
                            control={
                              <Checkbox
                                checked={p.checked}
                                onChange={(e) => handleCheck(e, p, c)}
                                name={`${p.formaat} (${p.shippingcost})`}
                              />
                            }
                            label={
                              <div className={`${classes.productText} ${classes.typograph}`}>
                                <b>{p.naam}  </b>
                                {/* <span>{p.formaat}</span> */}
                                {p.actie_prijs === null || p.actie_prijs === "0" ? (
                                    <span style={{ display: "flex" }}>€{p.prijs}</span>
                                  ) : (
                                  <span style={{ display: "flex" }}>
                                  <del> €{p.prijs} </del>
                                  <span>, €{p.actie_prijs}</span>
                                </span>
                                )}
                              </div>
                            }
                          />

                        </Grid>
                        {/* <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                          {p.quantum_aantal !== null &&
                            p.quantum_perc !== null && (
                              <Alert severity="info">
                                {p.quantum_aantal !== null
                                  ? `${props.t(
                                      "shoppage:With a quantity of "
                                    )}${p.quantum_aantal} ${props.t(
                                      "shoppage:Or more of this product you will receive "
                                    )}`
                                  : null}
                                {p.quantum_perc !== null
                                  ? `${p.quantum_perc}% ${props.t(
                                      "shoppage:Discount"
                                    )}`
                                  : null}
                              </Alert>
                            )}
                        </Grid> */}
                      </Grid>
                    ))}
                  </FormGroup>
                </FormControl>

            </AccordionDetails>
          </Accordion>
      : 
      <Accordion
            key={c.categorie_id}
            style={{ boxShadow: "none" }}
            expanded={expanded === c.categorie_id}
            onChange={handleChange(c.categorie_id)}
          >
            <AccordionSummary
              expandIcon={
                expanded === c.categorie_id ? <RemoveIcon /> : <AddIcon />
              }
              aria-controls={`${c.categorie_id}bh-content`}
              id={`${c.categorie_id}bh-header`}
            >
              <Typography className={`${classes.heading} ${classes.typograph}`} align="left">{c.naam}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={classes.typograph}>
                <FormControl className={classes.formControl}>
                  <FormGroup>
                    {c.catproducts.map((p) => (
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <FormControlLabel
                            key={p.product_id}
                            control={
                              <Checkbox
                                checked={p.checked}
                                onChange={(e) => handleCheck(e, p, c)}
                                name={`${p.formaat} (${p.shippingcost})`}
                              />
                            }
                            label={
                              <div className={`${classes.productText} ${classes.typograph}`}>
                              <b>{p.naam} </b>
                              {/* <span>{p.formaat}</span> */}
                              {p.actie_prijs === null || p.actie_prijs === "0" ? (
                                  <span style={{ display: "flex" }}>€{p.prijs}</span>
                                ) : (
                                <span style={{ display: "flex" }}>
                                <del> €{p.prijs} </del>
                                <span>, €{p.actie_prijs}</span>
                              </span>
                              )}
                            </div>
                            }
                          />

                        </Grid>
                        {/* <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                          {p.quantum_aantal !== null &&
                            p.quantum_perc !== null && (
                              <Alert severity="info">
                                {p.quantum_aantal !== null
                                  ? `${props.t(
                                      "shoppage:With a quantity of "
                                    )}${p.quantum_aantal} ${props.t(
                                      "shoppage:Or more of this product you will receive "
                                    )}`
                                  : null}
                                {p.quantum_perc !== null
                                  ? `${p.quantum_perc}% ${props.t(
                                      "shoppage:Discount"
                                    )}`
                                  : null}
                              </Alert>
                            )}
                        </Grid> */}
                      </Grid>
                    ))}
                  </FormGroup>
                </FormControl>
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
        
      <GeneralButton
        startIcon={<AddShoppingCartIcon />}
        className={classes.button}
        onClick={(e) => props.addTo(e, data, props.photo_id)}
        >
        {props.t("events:In shoppingcart")}
      </GeneralButton>

    </div>
  );
}

export default React.memo(
  withTranslation(["message", "shoppage", "events"])(AccordionCategories)
);
